export const ENV = Object.assign({
    REACT_APP_CURRENCY_CODE: "UAH",
    REACT_APP_CURRENCY_SYMBOL: "₴"
  },
  process.env, window._env_
);

export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100];

export default ENV;